import { render, staticRenderFns } from "./dabiao.vue?vue&type=template&id=1ab519ee&scoped=true&"
import script from "./dabiao.vue?vue&type=script&lang=ts&"
export * from "./dabiao.vue?vue&type=script&lang=ts&"
import style0 from "./dabiao.vue?vue&type=style&index=0&id=1ab519ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab519ee",
  null
  
)

export default component.exports